let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9IMDm")).then(() => parcelRequire('8GNxX'));